import { useFeatureFlag } from '@/hooks/useFeatureFlag'
import { programsNewCollection, ProgramsNewModel } from '@/reducers/programsNew'
import { ResourceModelQueryResult } from '@/request/types'

function eligibleForSCEBolt(p: ResourceModelQueryResult<ProgramsNewModel>[]) {
  return Boolean(p.find((p) => p.utility_program.name === 'SCE Bolt'))
}

export function useShowEnergySystem() {
  const featureFlagOn = useFeatureFlag({
    flag: 'connect_energy_system',
    experimentalValue: true,
  })
  const { data: programs } = programsNewCollection.useFetch()

  return featureFlagOn && eligibleForSCEBolt(programs)
}
